import $ from "jquery";
import { endsWith } from "./typescript/Vgr.Util";
import {
    handleKeyDown,
    getScopeUrlParam,
    getHsaIdUrlParam,
    addSearchQueries,
    addWww,
    addDokument,
    addVerksamhet,
    addPerson,
    addCloseResultContainerListener,
} from "./AutocompleteUtil";

const lang = document.documentElement.getAttribute('lang');

//*********Extended Autocomplete*********//
export default function initializeAutocomplete() {
    let useAutocomplete = $(document.body).data("useautocomplete") == true;

    if (!useAutocomplete) return;

    let urlPath = "/hittasearch/hittaquerycompletion";
    let arrowLeft = 37;
    let arrowUp = 38;
    let arrowRight = 39;
    let arrowDown = 40;
    let tab = 9;
    let escape = 27;
    let searchField = $("#search");
    let resultContainer = $("#autocomplete-result");
    let searchButton = $("#search-button");
    let topDiv = $("#result-topdiv");
    let bottomDiv = $("#result-bottomdiv");

    resultContainer.append(topDiv);
    resultContainer.append(bottomDiv);
    addCloseResultContainerListener(searchField, searchButton, resultContainer);
    searchField.on("keydown", function (event) {
        if (
            event.keyCode === arrowDown ||
            event.keyCode === arrowUp ||
            event.keyCode === arrowRight ||
            event.keyCode === arrowLeft ||
            event.keyCode === tab ||
            event.keyCode === escape
        ) {
            urlPath = "";
            let autoCompleteLinks = document.querySelectorAll(".autocomplete__link");

            autoCompleteLinks.forEach(function (el) {
                el.addEventListener("keydown", function (event) {
                    if (
                        event.keyCode === arrowDown ||
                        event.keyCode === arrowUp ||
                        event.keyCode === arrowRight ||
                        event.keyCode === arrowLeft ||
                        event.keyCode === tab ||
                        event.keyCode === escape
                    ) {
                        event.preventDefault();
                        handleKeyDown(event);
                    }
                });
            });

            handleKeyDown(event);
        } else {
            urlPath = "api/querycompletions/websearch";
            let scope = getScopeUrlParam();
            let hsaid = getHsaIdUrlParam();

            searchField.autocomplete({
                minLength: 1,
                delay: 0,
                source: function (request, response) {
                    $.ajax({
                        dataType: "json",
                        url: urlPath,
                        type: "Get",
                        data: {
                            q: request.term == undefined || request.term == null || request.term == ' ' ? "*" : request.term,
                            s: scope,
                            hsaids: hsaid,
                            category: "www",
                            lang: lang
                        },
                        success: function (data) {
                            if (data === "") return;
                            let jsObject = JSON.parse(data);
                            if (jsObject.suggestions.length === 0) {
                                resultContainer.addClass("hidden");
                                return;
                            }
                            topDiv.html("");
                            bottomDiv.html("");

                            resultContainer.removeClass("hidden");
                            resultContainer.removeClass("visually-hidden");
                            let searchQueries = $(jsObject.suggestions).filter(function (
                                i,
                                n
                            ) {
                                return n.category === "search_query";
                            });
                            let www = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "www";
                            });
                            let dokument = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "dokument";
                            });
                            let verksamhet = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "verksamhet";
                            });
                            let person = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "person";
                            });

                            addSearchQueries(searchQueries, topDiv);
                            addWww(www, topDiv);
                            addDokument(dokument, bottomDiv);
                            let isInternal = document.querySelector("input[name=isInternal]");
                            if (isInternal?.value == "True")
                                addPerson(person, bottomDiv, false);
                            else
                                addVerksamhet(verksamhet, bottomDiv, false);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.error(errorThrown)
                        },
                    });
                },
            });
        }
    });
}
